import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Footer from "./footer";

const Taskmanagment = () => {
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://billpunch.com/SeoBix/seo_injection.php?webid=9d59d8c77c932613971c6c6c6af12ce8&url=${encodedUrl}&baseUrl=https%3A%2F%2Fbillpunch.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      <Navbar />
      <h1 className="text-center mt-4 px-5 mx-5">
        Best Task Management Software in India 2025 – Organize & Track Workflows
        Efficiently
      </h1>
      <div className="d-flex justify-content-center">
        <img
          src="https://billpunch.com/billpunchImages/Workday%20a%20Breeze.png"
          style={{ height: "50vh" }}
        />
      </div>
      <div className="row mt-md-2">
        <div className="col-md-1"></div>
        <div className="col-md-8">
          <h2>Simplify Task Planning & Enhance Productivity</h2>
          <p>
            Tasks complete effectively, enhancing productivity, and then
            eventually achieving deadlines. BillPunch Task Management Software
            is the Internet-based, cloud-hosted application for real-time
            assignment, tracking, and management of any task. BillPunch Task
            Management Software automated task tracking to ensure accountability
            while executing both daily operations and teamwork or client
            projects.
          </p>

          <h5>BillPunch's Task Management Software Key Features</h5>

          <h5>Smart Creation & Assignment of Tasks</h5>
          <ul>
            <li>
              Create tasks to assign them with deadlines and dependencies using
              drag-and-drop management for organization.
            </li>
          </ul>

          <h5>Real-Time Collaboration & Notifications</h5>
          <ul>
            <li>
              Instant task updates and reminders are sent to team members.
            </li>
            <li>Share comments and files within the application.</li>
          </ul>

          <h5>Automated Workflow Manager:</h5>
          <ul>
            <li>
              You can make dependencies between tasks and automate repetitive
              actions.
            </li>
          </ul>

          <h5>Track time and productivity features: </h5>
          <ul>
            <li>
              Improving on the efficiency with which you track time done against
              your tasks.
            </li>
            <li>
              Extend detailed reporting against individual activity and team
              performance.
            </li>
          </ul>

          <h5>Mobile Support & Cloud Synchronization:</h5>
          <ul>
            <li>Access tasks across devices with mobile app support</li>
            <li>Cloud synchronization on tasks for remote teams</li>
          </ul>

          <h5>Why BillPunch Offers Task Management?</h5>
          <ul>
            <li>Smart task automation to boost team productivity.</li>
            <li>
              Collaborative environment enhanced with real-time task tracking.
            </li>
            <li>
              Become more efficient through detailed performance analytics.
            </li>
            <li>
              Reduce workload stress via the automation of repetitive tasks.
            </li>
          </ul>
        </div>

        <div className="col-md-1"></div>
      </div>

      <Footer />
    </>
  );
};

export default Taskmanagment;
